import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import DashboardPage from './pages/DashboardPage';
import AddTiepPage from './pages/AddTiepPage';
import IssueGoodsPage from './pages/IssueGoodsPage';
import TiepGoodsPage from './pages/TiepGoodsPage';
import MudFormPage from './pages/MudFormPage';
import UsersPage from './pages/UsersPage';
import ProfilePage from './pages/ProfilePage';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', color:'#64748b' }}>Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user?.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

// Root "/" — shows login form if logged out, redirects to dashboard if already logged in.
// This removes the need to type "/login" in the URL.
function RootRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && !user.must_change_password) return <Navigate to="/dashboard" replace />;
  if (user && user.must_change_password) return <Navigate to="/change-password" replace />;
  return <LoginPage />;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && !user.must_change_password) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/forgot-password" element={<GuestOnly><ForgotPasswordPage /></GuestOnly>} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="add-tiep" element={<AddTiepPage />} />
              <Route path="issue-goods" element={<IssueGoodsPage />} />
              <Route path="tiep-goods" element={<TiepGoodsPage />} />
              <Route path="mud-form" element={<MudFormPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="admin/users" element={<RequireAdmin><UsersPage /></RequireAdmin>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
